import React, { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import {
  getQrPreviewSize,
  mapApiQrOptionsToStyling,
} from "../../../common/CertificateOnboarding/utils/qr";

function QrCodePreviewFromOptions({ qrCodeOptions, data, className = "" }) {
  const containerRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const { width, height } = getQrPreviewSize(qrCodeOptions);
    const dotsOptions = mapApiQrOptionsToStyling(qrCodeOptions);

    if (!instanceRef.current) {
      container.replaceChildren();
      instanceRef.current = new QRCodeStyling({
        width,
        height,
        data: data || "{}",
        dotsOptions,
        backgroundOptions: { color: "#ffffff" },
        cornersSquareOptions: { type: "extra-rounded" },
      });
      instanceRef.current.append(container);
      return;
    }

    instanceRef.current.update({
      width,
      height,
      data: data || "{}",
      dotsOptions,
    });
  }, [qrCodeOptions, data]);

  useEffect(() => {
    return () => {
      instanceRef.current = null;
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`flex items-center justify-center ${className}`}
      aria-hidden
    />
  );
}

export default QrCodePreviewFromOptions;
